<template>
  <div class="aboutPage">

    <div class="fullpage-container hidden-sm-down">
      
      <div class="visual_switch">
        <div class="switch" 
              v-bind:class="{ active: curProduct === 0 }"
              v-on:click="scrollToProduct(0)"></div>
        <div class="switch" 
              v-bind:class="{ active: curProduct === 1 }"
              v-on:click="scrollToProduct(1)"></div>
      </div> 

      <div class="fullpage-container__bgImg"></div>
      <div class="fullpage-wp" v-fullpage="opts" ref="fullpage">
        
        <div class="page-1 page">
          <div class="fullpage-container__title">
            關於「威滅<sup class="fullpage-container__title__tm">&reg;</sup>」
          </div>
          <div class="fullpage-container__subTitle">
            多年歷史，配方專業獨特，真正殺蟲的專家。
          </div>
          <div class="fullpage-container__bottomPanel">
            <p class="fullpage-container__bottomPanel__text1">
              威滅<sup>&reg;</sup>為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。
            </p>
            <p class="fullpage-container__bottomPanel__text2">
              產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅<sup>&reg;</sup>一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 
            </p>   
            <img class="fullpage-container__bottomPanel__productImage" src="../assets/about-section2.png"/>
            <div class="claimRef">
              <div>
                <!-- *資料來源：Home Care: Euromonitor from trade sources/national statistics. -->
                *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
              </div>
              <!-- <div>
                URL: http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
              </div> -->
            </div>

          </div>
          <div class="pageControl">
            <button data-button="next" class="" @click="moveNextPage">
              <span class="item item-half item-icon white">
                <svg class="icon icon-arrow icon-rotate-down" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                  <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <div class="page-2 page">
          <contact></contact>
          <div id="bottomArrow" class="pageControl">
            <button data-button="next" class="" @click="movePrevPage">
              <span class="item item-half item-icon white">
                <svg class="icon icon-arrow icon-rotate-up" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                  <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                </svg>
              </span>
            </button>
          </div>
          <henkel-footer></henkel-footer>
        </div>
      </div>
    </div>


    <div class="hidden-md-up">
      <div class="section1">
        <img src="../assets/about-section1.jpg"/>

      </div>
      <div class="section2">

        <p class="title">
          關於「威滅<sup class="title__tm">&reg;</sup>」
        </p>
        <p class="subTitle">
          多年歷史，配方專業獨特，真正殺蟲的專家。
        </p>

        <div class="text">
          <p class="text1">
            威滅<sup>&reg;</sup>為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。
          </p>
          <p class="text2">
            產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅<sup>&reg;</sup>一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 
          </p>    
        </div>
        <img src="../assets/about-section2-m.png"/>
        
        <div class="claimRef">
          <div>
            <!-- *資料來源：Home Care: Euromonitor from trade sources/national statistics. -->
            *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
          </div>
          <!-- <div>
            URL: http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
          </div> -->
        </div>
      </div>
      <contact></contact>
      <henkel-footer></henkel-footer>
    </div>

  </div> 
</template>

<script>
export default {
  head: {
    meta: [
      { name: 'application-name', content: 'combat about' }
    ]
  },
  data () {
    return {
      tabIndex: 1,
      curProduct: 0,
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: (obj, prev, next) => {
          this.curProduct = next
        },
        afterChange: (obj, prev, next) => {
        }
      }
    }
  },
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  mounted () {
    window.onresize = () => {
      var vw = document.documentElement.clientWidth
      if (vw >= 780 && !this.openOverlay) {
        location.reload()
      }
    }
  },
  methods: {
    movePrevPage () {
      this.$refs.fullpage.$fullpage.movePrev()
    },
    moveNextPage () {
      this.$refs.fullpage.$fullpage.moveNext()
    },
    scrollToProduct (index) {
      this.curProduct = index
      this.$refs.fullpage.$fullpage.moveTo(index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_fullpage.sass"
@import "../styles/_pageControl.sass"
@import "../styles/_visualSwitch.sass"

.aboutPage
  padding-top: $topMenu-height
  left: 0
  top: 0
  width: 100vw

  .fullpage-container
    @include fullpage-container

    .visual_switch
      @include visualSwitch
      @media only screen and (max-width: 768px)
        display: none
    
    .pageControl
      @include pageControl

    .page-2
      .pageControl
        bottom: 195px

    &__title
      bottom: 380px

      &__tm
        font-size: 30%
        vertical-align: super

    &__subTitle
      bottom: 330px

    &__bottomPanel
      height: 300px
      font-size: 16px

      @media only screen and (max-width: 1016px)
        font-size: 1.5vw

      &__productImage
        bottom: 25%
        width: 80%
        right: 4%
        max-width: 50vw

      .claimRef
        right: 0
        position: absolute
        padding-right: 20px
        text-align: right
        font-size: 10px
        bottom: 4%

    .footer
      position: absolute
      width: 100%
      bottom: 0

  .title
    font-size: 6vw
    line-height: 35px
    padding-right: 73px

    &__tm
      font-size: 50%
      vertical-align: super

  .subTitle
    font-size: 3.5vw
    line-height: 25px
    padding-right: 73px

  .section1
    position: relative
    background-color: #08080b
    width: 100%
    overflow: auto
    max-height: 500px
    overflow: hidden

    img
      width: 100%

    p
      color: white
      position: absolute
      left: 64px

      &.title
        bottom: 70px

        @media only screen and (max-width: 320px)
          bottom: 25%

      &.subTitle
        bottom: 5%

        @media only screen and (max-width: 320px)
          bottom: 0
          line-height: 15px

  .section2
    background-color: $theme-yellow
    padding-top: 64px
    padding-bottom: 15vw
    padding-right: 73px
    padding-left: 73px
    overflow: auto
    font-size: 16px

    @media only screen and (max-width: 768px)
      padding: 30px
    
    .text
      color: black
      width: 40%
      float: left

      @media only screen and (max-width: 768px)
        width: 100%
        float: none
      
      @media only screen and (min-width: 1920px)
        width: 50%

    .title
      font-size: 30px
      line-height: 35px
      font-weight: bold
      padding-right: 30px

    .subTitle
      font-size: 18px
      margin-bottom: 10%
      padding-right: 30px
    
    .text1, .text2
      line-height: 25px
      font-size: 1.2em

    div
      word-break: break-all

    img
      float: right
      width: 55%
      // margin-top: -25px

      @media only screen and (max-width: 768px)
        width: 100%
        float: none
        margin-top: -25px
      
      @media only screen and (min-width: 1920px)
        width: 74vh
        margin-top: 0

    .claimRef
      font-size: 10px
      margin-top: 20px


</style>



// WEBPACK FOOTER //
// About.vue?b4f2b04c